import { makeStyles } from 'tss-react/mui'

/**
 * Caches one tss-react styles hook per `styles` function reference.
 *
 * tss-react's `makeStyles()` must run once per style definition, never per
 * render. The style functions passed to this hook are module-level constants,
 * so we build (and memoize) one hook per function reference and forward the
 * render-time props to it as tss-react params.
 *
 * @type {WeakMap<Function, Function>}
 */
const stylesHooks = new WeakMap()

const getStylesHook = (styles) => {
  let useStylesHook = stylesHooks.get(styles)

  if (!useStylesHook) {
    useStylesHook = makeStyles()((theme, props) => styles(theme, props))
    stylesHooks.set(styles, useStylesHook)
  }

  return useStylesHook
}

/**
 * Material Ui Hook useStyles.
 *
 * Removes the need to imperatively use HoC withStyles()
 *
 * @param {function} styles styles function
 * @param {Object} props    additional props
 * @returns {() => Object}
 */
const useStyles = (styles, props = {}) => {
  const useStylesHook = getStylesHook(styles)

  return () => useStylesHook(props).classes
}

export default useStyles
